import { render } from "./EditAppointmentLab.vue?vue&type=template&id=64626ada&scoped=true"
import script from "./EditAppointmentLab.vue?vue&type=script&lang=js"
export * from "./EditAppointmentLab.vue?vue&type=script&lang=js"

import "./EditAppointmentLab.vue?vue&type=style&index=0&id=64626ada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64626ada"]])

export default __exports__